<h3 class="mb-3">{{ name }}'s Progress report</h3>
<div class="row">
  <div class="col-md-4">
    <div class="form-group">

      <label for="name">Name</label>
      <div class="form-control readonly" [innerHTML]="name">

      </div>
    </div>
  </div>
  <div class="col-md-4">
    <div class="form-group">
      <label for="grade">Outcome</label>
      <div class="form-control readonly"
        [innerHTML]="progressReport.decision === 999 ? 'Unsatisfactory': 'Satisfactory'">

      </div>
    </div>
  </div>

  <div class="col-md-4">
    <div class="form-group">
      <label for="submittedAt">Designated supervisor's registration number</label>
      <div style="min-height: 40px;" class="form-control readonly"
        [innerHTML]="progressReport.registrationNumber">
      </div>
    </div>
  </div>


  <div class="col-md-4">
    <div class="form-group">
      <label for="submittedAt">Submitted at</label>
      <div style="min-height: 40px;" class="form-control readonly" [innerHTML]="submittedAt | utcDate">

      </div>
    </div>
  </div>


</div>
<div class="row">
  <div class="col-md-12">
    <div class="form-group">
      <label for="submittedAt">Identity Proof</label>
      <div style="min-height: 40px;" class="form-control readonly">
        <app-application-supporting-docs [application]="application" [isPrescriber]="true" [isAros]="true" [isStudent]="true"
          [isCountersignerView]="true">
        </app-application-supporting-docs>
      </div>
    </div>
  </div>
</div>
<div class="row">
  <div class="col-md-4">
    <div class="form-group">
      <label for="">Annual leave</label>
      <div class="form-control readonly" [innerHTML]="countersignerComment.annualLeaves"></div>
    </div>
  </div>
  <div class="col-md-4">
    <div class="form-group">
      <label for="">Sickness</label>
      <div class="form-control readonly" [innerHTML]="countersignerComment.sickLeaves"></div>
    </div>
  </div>
  <div class="col-md-4">
    <div class="form-group">
      <label for="">Other</label>
      <div class="form-control readonly" [innerHTML]="countersignerComment.otherLeaves"></div>
    </div>
  </div>
</div>


<div class="row">

  <div class="col-md-12 mb-2">
    <h4>Designated supervisor feedback</h4>
  </div>

  <div class="col-md-12">
    <div class="form-group">

      <label for="tutorFeedback">
        Comments on your trainee’s progress to date with regards to the interim learning outcomes, the registration
        assessment
        framework, and calculation questions
      </label>
      <div class="form-control readonly" [innerHTML]="countersignerComment.traineeProgressComments">

      </div>
    </div>
  </div>
  <div class="col-md-12">
    <div class="form-group">

      <label for="tutorFeedback">
        Do you feel that any problems, work-related or personal, have affected your trainee’s performance? If
        “Yes” please give details (if the trainee is happy for them to be disclosed)
      </label>
      <div class="form-control readonly"
        [innerHTML]="countersignerComment.problemDetails ? countersignerComment.problemDetails : 'No'">

      </div>
    </div>
  </div>
  <div class="col-md-12">
    <div class="form-group">

      <label for="tutorFeedback">
        Reason for other leaves by trainee
      </label>
      <div class="form-control readonly"
        [innerHTML]="countersignerComment.otherLeaveDetails ? countersignerComment.otherLeaveDetails : 'No other leave details'">

      </div>
    </div>
  </div>
  <div class="col-md-12">
    <div class="form-group">

      <label for="tutorFeedback">
        Any other comments by designated supervisor?
      </label>
      <div class="form-control readonly" [innerHTML]="countersignerComment.commentsByTutor">

      </div>
    </div>
  </div>


</div>
@if (!(confirmedTempRegistration===null)) {
  <div class="row">
    <div class="col-md-12 mb-2">
      <h4>Temporary Registration</h4>
    </div>
    <div class="col-md-12">
      <div class="form-group">
        <div class="form-control readonly" [innerHTML]="confirmedTempRegistration === true ? 'Yes': 'No'">
        </div>
      </div>
    </div>
  </div>
}
<div class="row">
  <div class="col-md-12 mb-2">
    <h4>Trainee comments</h4>
  </div>
  <div class="col-md-12">
    <div class="form-group">

      <div class="form-control readonly"
        [innerHTML]="countersignerComment.traineeFeedbackOnTutorAssessment ? countersignerComment.traineeFeedbackOnTutorAssessment : 'No comments'">

      </div>
    </div>
  </div>
</div>